module.exports = __webpack_public_path__ + "img/merit_icon3.12aaae95.png";